export enum MispickPopupField {
    LineItemId = 0,
    Upc = 1,
    Quantity = 2,
    ReasonCode = 3,
    ShortedItemId = 4,
    ReturnSticker = 5,
    NoReturnSticker = 6,
    Comments =7
}